// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d799a215","977":"5a90e11b"}[chunkId] + ".chunk.js";
};